export default __webpack_public_path__ + "static/media/logoCaritas.95ed0ad5.jpg";